import React from 'react';
import { StickyNote, Mic, Pencil } from 'lucide-react';

export function EmptyNotes() {
  return (
    <div className="h-full flex items-center justify-center p-8">
      <div className="max-w-md text-center flex flex-col items-center justify-center">
        <div className="relative mb-8">
          <div className="relative w-24 h-24 mx-auto">
            {/* Glow effect */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl opacity-75 blur-lg transform transition-all duration-200 group-hover:scale-110" />

            {/* Main icon */}
            <div className="relative w-24 h-24 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-[0_8px_16px_rgba(59,91,219,0.2)] transform transition-all duration-200 hover:scale-110 hover:shadow-[0_12px_24px_rgba(59,91,219,0.3)]">
              <StickyNote className="w-12 h-12 text-white" />
            </div>

            {/* Decorative icons */}
            <div className="absolute -top-2 -right-2 w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center transform rotate-12 shadow-sm">
              <Mic className="w-4 h-4 text-yellow-600" />
            </div>
            <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center transform -rotate-12 shadow-sm">
              <Pencil className="w-4 h-4 text-green-600" />
            </div>
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-4 font-sora">No Notes Yet</h2>

        <p className="text-gray-600 mb-8 text-lg leading-relaxed">
          Start adding notes by typing below or using voice recording.
        </p>

        <div className="w-full flex items-center justify-center gap-3 text-gray-500 text-base mb-6">
          Supported interactions include:
        </div>
        <div className="flex justify-center gap-4 mb-8">
          <div className="flex items-center gap-2">
            <Pencil className="w-5 h-5 text-blue-500" />
            <span>Text Notes</span>
          </div>
          <div className="flex items-center gap-2">
            <Mic className="w-5 h-5 text-green-500" />
            <span>Voice Notes</span>
          </div>
        </div>
      </div>
    </div>
  );
}
